import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`→`}{` 20% off on AI Engineer course - `}<a parentName="p" {...{
        "href": "https://scrimba.com/?via=u02nb6"
      }}>{`Check it out`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      